// SamplingEventRouteUtils.js
// Helpers to parse and build canonical /home/sampling_events routes

const BASE = "/home/sampling_events";

export function parseSamplingEventsRoute(pathname, search) {
  if (!pathname || !pathname.startsWith(BASE)) return {};
  const parts = pathname.split("/").filter(Boolean); // ["home", "sampling_events", ...]
  const seg = parts[2] || null; // e.g., "new" or "event_form"

  let mode = "table"; // table | create | event
  if (seg === "new") mode = "create";
  if (seg === "event_form") mode = "event";
  if (seg === "well_uploads") mode = "well_uploads";

  const params = new URLSearchParams(search || "");
  const eventId = params.get("event_id") || null;

  return { mode, eventId };
}

export function buildSamplingEventsPath({ mode, eventId }) {
  if (mode === "create") return `${BASE}/new`;
  if (mode === "event") {
    const query = new URLSearchParams();
    if (eventId) query.set("event_id", eventId);
    const qs = query.toString();
    return qs ? `${BASE}/event_form?${qs}` : `${BASE}/event_form`;
  }
  if (mode === "well_uploads") return `${BASE}/well_uploads`;
  return BASE; // table
}

export function canonicalizeSamplingEventsLocation(locationLike) {
  const pathname = locationLike?.pathname || "";
  const search = locationLike?.search || "";
  if (!pathname.startsWith(BASE)) return null;
  const parsed = parseSamplingEventsRoute(pathname, search);
  const canonical = buildSamplingEventsPath(parsed);
  const current = `${pathname}${search || ""}`;
  return canonical !== current ? canonical : null;
}
